import { t } from '@lingui/core/macro';
import { SidebarLoader } from 'app/domains/documents/SidebarLoader';
import { PollingState } from '../PollingState';
export function CreatingState(props) {
    const { polling = true, overlay = false } = props;
    const title = t({
        message: 'Sending document for e-signing',
        comment: 'Message when the document is being sent for e-signing',
    });
    const message = t({
        message: 'Waiting for the e-signing provider. This may take a moment.',
        comment: 'Descriptive message when the document is being sent for e-signing',
    });
    if (polling) {
        return <PollingState overlay={overlay} title={title} message={message}/>;
    }
    return <SidebarLoader overlay={overlay} title={title} message={message}/>;
}
